import { GridRenderCellParams } from '@mui/x-data-grid';
import classNames from 'classnames';

import { RecapAsset } from '@/api/trading/types';
import { AssetIcon } from '@/blocks/components/AssetIcon';
import { LinkAsset } from '@/blocks/components/PlatformLink';
import { SparklineChart } from '@/blocks/components/SparklineChart';
import { IconPriceTrend } from '@/blocks/components/Table/IconPriceTrend/IconPriceTrend';
import { WithTrendColor } from '@/blocks/components/WithTrendColor';
import { FormatAssetName, FormatPercent, FormatPrice } from '@/blocks/formatters';
import { extractAssetDescription, extractAssetName } from '@/blocks/formatters/format-asset-name';
import buttons from '@/styles/button.module.scss';
import typography from '@/styles/typography.module.scss';

import styles from './styles.module.scss';

export const isTradable = (asset: any) => asset?.tradable;

export function renderCellAsset(params: GridRenderCellParams<RecapAsset>) {
  return (
    <div className={styles.assetCell}>
      <AssetIcon assetName={params.row.name} loading={'eager'} />
      <div>
        <span className={styles.assetFullName}>
          <FormatAssetName assetName={extractAssetName(params.row)} />
        </span>
        <span className={classNames(typography.bodyS, styles.assetName)}>
          <FormatAssetName assetName={extractAssetDescription(params.row)} />
        </span>
      </div>
    </div>
  );
}

export function renderCellPriceAndChange(params: GridRenderCellParams<RecapAsset>) {
  if (!isTradable(params.row)) {
    return null;
  }
  return (
    <div className={classNames(styles.priceAndChangeCell)}>
      <div>
        <IconPriceTrend negative={params.row.change24h < 0} />
        <FormatPrice price={params.row.price} priceScale={params.row.priceScale} />
      </div>
      <div>
        <WithTrendColor valueToCalculateTrend={params.row.change24h}>
          <FormatPercent value={params.row.change24h} forcePlusSign={true} />
        </WithTrendColor>
      </div>
    </div>
  );
}

export function renderCellAssetTrend(params: GridRenderCellParams<RecapAsset>) {
  return isTradable(params.row) ? (
    <SparklineChart chartValues={params.row.trend} negative={params.row.change24h < 0} />
  ) : null;
}

export function renderCellCta({ text, enText }: { text: string; enText: string }) {
  // eslint-disable-next-line react/display-name
  return (params: GridRenderCellParams<RecapAsset>) => {
    if (!isTradable(params.row)) {
      return null;
    }

    return (
      <LinkAsset
        asset={params?.row}
        className={classNames(buttons.btn, buttons.btnXXS, buttons.btnOutline)}
        data-column-name={'actions'}
        data-event-label={enText}
      >
        {text}
      </LinkAsset>
    );
  };
}

export function renderCellPrice(params: GridRenderCellParams<RecapAsset>) {
  if (!isTradable(params.row)) {
    return null;
  }

  return (
    <div className={styles.priceCell}>
      <IconPriceTrend negative={params.row.change24h < 0} />
      <span className={styles.price}>
        <FormatPrice price={params.row.price} priceScale={params.row.priceScale} />
      </span>
    </div>
  );
}
